import { Product, Variant } from "../../types/types";
import { isAvailableToPreOrder } from "../variant/isAvailableToPreOrder";
import { isFutureRelease } from "../variant/isFutureRelease";

export function hasAnyStock(product: Product): boolean {
  return Boolean(product.variants?.some(variantHasStock));
}

function variantHasStock(variant: Variant): boolean {
  return (
    Boolean(variant.availability?.availableToOrder) ||
    isFutureRelease(variant) ||
    isAvailableToPreOrder(variant)
  );
}
